import { render, staticRenderFns } from "./bidui-detail.vue?vue&type=template&id=226f28d8&"
import script from "./bidui-detail.vue?vue&type=script&lang=ts&"
export * from "./bidui-detail.vue?vue&type=script&lang=ts&"
import style0 from "./bidui-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports